<template>
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_110_4599)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 0.5C37.2548 0.5 48 11.2452 48 24.5C48 37.7548 37.2548 48.5 24 48.5C10.7452 48.5 0 37.7548 0 24.5C0 11.2452 10.7452 0.5 24 0.5ZM24 13C13.2476 13 4.53125 18.1487 4.53125 24.5C4.53125 30.8513 13.2476 36 24 36C34.7523 35.9999 43.4688 30.8512 43.4688 24.5C43.4688 18.1488 34.7523 13.0001 24 13Z"
        fill="#1F9AFF"
      />
      <path
        d="M22.509 30.647L18.967 21.6636H18.89L18.967 22.331V30.647H15.0657V17.6083H20.2503L23.7923 26.7713H23.818L27.36 17.6083H32.5447V30.647H28.6433V22.331L28.7203 21.6636H28.6433L25.1013 30.647H22.509Z"
        fill="#1F9AFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_110_4599">
        <rect
          y="0.5"
          width="48"
          height="48"
          rx="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>